<template>
    <div class="container">
<!-- <h2>Tipo de Equipos</h2>
<v-divider></v-divider> -->
        
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="11">
                            <v-card-title class="titulopagina">ADMINISTRAR LOTES</v-card-title>
                        </v-col>
                        <v-col cols="1">
                            <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                                <v-icon color="blue" large>help</v-icon>
                            </v-alert>
                        </v-col>
                    </v-row>                
                </v-card-text>
            </v-card>
            <modal-ayuda></modal-ayuda>
            <v-card>
                <v-card-text>
                    Crear Nuevo
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>
            <tabla-paginada @cargar="cargar" @editar="editar($event)" @muestreos="muestreos($event)"></tabla-paginada>
            <!-- <data-table class="mt-5" @editar="editar($event)" @cerrar_lote="abrir_modal_confirmacion($event)"></data-table> -->

            <!-- <modal @peticionrealizada="cargarDatos"></modal> -->

            <modal-confirmacion @confirmar="cerrar_lote($event)"></modal-confirmacion>

            <modal-lotes @realizado="cargar('?limit=20')"></modal-lotes>
            <modal-muestreos></modal-muestreos>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import Tabla from '@/components/shared/Tabla.vue';
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Modal_Confirmacion from '@/components/shared/Modal_Confirmacion.vue';
import Modal_Lotes from '../../components/shared/Modal_Lotes.vue';
import Modal_Muestreos from '@/components/shared/Modal_Muestreos.vue';
import TablaPaginadaVue from '../../components/shared/TablaPaginada.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        tipo_lotes:[],
        restricciones:[],
        especies:[],
        antioxidantes:[],
        antioxidante_nombres:[],
        estados:[
                {id:0,estado:'Abierto'},
                {id:1,estado:'Cerrado'}
        ],
        inputs:[
            {tipo:'fecha',valor:'',label:'Fecha Elaboración*',key:'fecha_produccion'},
            {tipo:'select',valor:'',label:'Seleccione Tipo de Lote*',key:'tipo_lotes_id',opciones:[],texto:'tipo_lote',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Especie*',key:'tipo_mps_id',opciones:[],texto:'tipo_materia_prima',seleccion:'id'},
            {tipo:'select',valor:'',label:'Nombre Antioxidante',key:'antioxidantes_id',opciones:[],texto:'nombre',seleccion:'id'},
            {tipo:'texto',valor:'',label:'N° Lote*',key:'nombre_lote'},
            {tipo:'select',valor:'',label:'Estado*',key:'estado',opciones:[],texto:'estado',seleccion:'id'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },

        //configuracion para datatable
        cabeceras:[
            {text: 'Fecha Elaboración',align: 'center',sortable: true,value: 'fecha_produccion',},
            {text: 'N° Lote',align:'center',sortable: false,value: 'nombre_lote'},
            {text: 'Tipo de Lote',align: 'center',sortable: true,value: 'tipo_lote',},
            {text: 'Especie',align: 'center',sortable: true,value: 'especie'},
            {text: 'Antioxidante',align: 'center',sortable: true,value: 'antioxidante',},
            {text: 'Nombre Antioxidante',align: 'center',sortable: true,value: 'antiox_c',},
            {text: 'Cantidad Maxisacos',align: 'center',sortable: true,value: 'cantidad'},
            {text: 'Estado',align: 'center',sortable: true,value: 'estado'},
            {text: 'Total (Kg)',align: 'center',sortable: true,value: 'peso'},
            {text: 'Acciones', value: 'action',sortable: false, align:'center'},
            {text: 'Cerrar Lote',value: 'cerrar_lote',sortable: false,align:'center'},
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true},
                {key:'muestreos',titulo:'Ver muestreos',visible:true},
        ],

        columnas:[
            {nombre:'Fecha Elaboración',tipo: 'date',path: 'fecha_produccion',key:'fecha_produccion',searchable:false,busqueda:''},
            {nombre:'N° Lote',tipo: 'texto',path: 'nombre_lote',key:'nombre_lote',searchable:true,busqueda:''},
            {nombre:'Tipo Lote',tipo: 'select',path: 'tipo_lote',key: 'tipo_lotes_id',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'tipo_lote'},
            {nombre:'Antioxidante',tipo: 'select',path: 'antioxidante',key:'antioxidantes_id',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Nombre Antioxidante',tipo: 'select',path: 'antiox_c',key:'anti_comerc_id',searchable:true,busqueda:'',opciones:[],valor_opcion:'id',texto_opcion:'nombre'},
            {nombre:'Total Maxisacos',tipo: 'numero',path: 'cantidad',searchable:false,busqueda:''},
            {nombre:'Estado',tipo:'select',path:'estado',key:'cerrado',searchable:true,busqueda:'',opciones:[{id:0, estado:'Abierto'},{id:1, estado:'Cerrado'}],valor_opcion:'id',texto_opcion:'estado'},
            {nombre:'Total (Kg)',tipo:'numero',path:'peso',key:'peso',searchable:false,busqueda:''},
            {nombre:'Editar',tipo:'evento',key:'evento',color:'#F57C00',icono:'create',evento:'editar'},
            {nombre:'Muestreos',tipo:'evento',key:'evento',color:'green',icono:'bar_chart',evento:'muestreos'},
        ],
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarTipoLotes();
        this.inputs[4].opciones = this.estados;
        this.columnas[5].opciones = this.estados;
        //this.cargar('?limit=10')
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Administrar Lotes`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se pueden administrar los lotes de Harina del sistema. Se muestra la fecha de elaboración, número de lote, tipo, antioxidante, nombre antioxidante, total maxisacos, estado, total (kg), y la opción de editar el lote y ver los muestreos de laboratorios externos (si es que los tuviera) listados en una tabla. Además, se pueden filtrar los registros por n° de lote, tipo de lote, antioxidantes y estado.`},
                {   tipo:`label`,   texto:`- Se puede crear un nuevo lote pulsando el botón "Crear Lote +" en donde se abrirá una ventana en la que se muestran los campos requeridos para la creación de un nuevo lote (n° de lote, nombre antioxidante, fecha elaboración y si es un lote cerrado). Para guardar el lote se debe pulsar el botón "Guardar"`},
                {   tipo:`label`,   texto:`- Al pulsar el botón con el icono del lápiz en la columna "Editar", se abrirá una ventana para la edición de los datos del lote. Para guardar los cambios se debe pulsar en botón "Guardar".`},
                {   tipo:`label`,   texto:`- Al pulsar el botón con el icono de un gráfico en la columna "Muestreos", se abrirá una ventana con una tabla en donde se muestran los muestreos importados desde laboratorios externos en el sistema, con su respectivo parámetro y valor (en caso de que hubieran).`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarTipoLotes(){
            this.mostrarLoading({titulo:'Cargando Tipos de Lote...',color:'green'})

            let url = `${this.base_url}tipo_lote`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Tipos de Lote',response);
                this.tipo_lotes = response.data.data;
                this.inputs[1].opciones = this.tipo_lotes;
                this.columnas[2].opciones = this.tipo_lotes;
                
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
            this.cargarAntioxidantesNombre();

        },

        async cargarAntioxidantesNombre(){
            this.mostrarLoading({titulo:'Cargando Nombre de Antioxidante...',color:'green'})

            let url = `${this.base_url}antioxidante_nombres`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Antioxidantes Nombre',response);
                this.antioxidante_nombres = response.data.data;
                this.columnas[4].opciones = this.antioxidante_nombres;
                
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
            this.cargarEspecies();

        },

        async cargar(query){
            await this.axios.get(`${this.base_url}lote/index_new${query}`,this.headers).then((res)=>{
                console.log(res.data.data);
                this.actualizarTablaPaginada({lista:res.data.data.data,columnas:this.columnas,total_paginas:res.data.data.last_page});
            }).catch((e)=>{
                console.log(e);
            });
            
        },
        // async cargarEspecies(){
        //     await this.axios.get(`${this.base_url}tipo_mps/configuracion/3`,this.headers).then((response)=>{
        //     this.especies = response.data;
        //     this.inputs[2].opciones = this.especies;
        //     console.log('especies',response.data);
        //     this.cargarDatos();
        //   }).catch((error)=>{
        //     console.log('error',error);
        //     this.ocultarLoading();            
        //   })
        // },

        async cargarEspecies(){
            //this.mostrarLoading('Cargando Materias Primas...');
            this.mostrarLoading({titulo:'Cargando Materias Primas...',color:'green'})

            await this.axios.get(`${this.base_url}configuracion_mp/3/tipo_mps`,this.headers).then((response)=>{
            this.especies = response.data.data;
            this.inputs[2].opciones = this.especies;
            console.log('materias primas',response.data.data);
            
          }).catch((error)=>{
            console.log('error',error);
            this.ocultarLoading();            
          })
          this.cargarAntioxidantes();
        },

        async cargarAntioxidantes(){
            //this.mostrarLoading('Cargando Antioxidantes...');
            this.mostrarLoading({titulo:'Cargando Antioxidantes...',color:'green'})

            await this.axios.get(`${this.base_url}antioxidantes`,this.headers).then((response)=>{
            this.antioxidantes = response.data.data;
            this.columnas[3].opciones = this.antioxidantes;
            console.log('antioxidantes',response.data.data);
            
          }).catch((error)=>{
            console.log('error',error);
            this.ocultarLoading();            
          })
          this.cargarRestricciones();
        },

        async cargarRestricciones(){
            //this.mostrarLoading('Cargando Restricciones...');
            this.mostrarLoading({titulo:'Cargando Restricciones...',color:'green'})

            let url = `${this.base_url}restricciones`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Restricciones',response);
                this.restricciones = response.data.data;
                this.inputs[2].opciones = this.restricciones;
                
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
            this.cargar('?limit=20');
            this.ocultarLoading();
        },

        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}lote/index_new`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                // this.lista.forEach(item => {
                //     item.fecha_produccion = this.moment(item.fecha_produccion).format('DD/MM/YYYY HH:mm');
                // });
                // Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            })
        },
        crear(){
            console.log('crear');
            // this.configuracion_modal.titulo_modal = 'Crear Lote';
            // this.configuracion_modal.boton_submit = 'Crear';
            // this.configuracion_modal.ruta = 'lotes';
            // this.configuracion_modal.tipo_peticion = 'POST';
            // this.$emit('abrir',this.inputs,this.configuracion_modal);
            let conf = {titulo:'Crear Nuevo Lote',tipo_peticion:'POST',materias_primas:this.especies,antioxidantes:this.antioxidantes,tipo_lotes:this.tipo_lotes,antioxidante_nombres:this.antioxidante_nombres};
            this.$emit('abrir_modal_lotes',conf,null);
        },

        editar($event){
            let conf = {titulo:'Editar Lote',tipo_peticion:'PUT',materias_primas:this.especies,antioxidantes:this.antioxidantes,tipo_lotes:this.tipo_lotes,antioxidante_nombres:this.antioxidante_nombres};
            this.$emit('abrir_modal_lotes',conf,$event.item);
        },
        muestreos($event){
            Event.$emit('abrir_modal_muestreos', $event.item, true);
        },
        // async editar($event){
        //     console.log('editando',$event);
        //     //por cada input se realiza el seteo correspondiente del item que se esta editando
        //     this.inputs.forEach(input => {
        //         //recorrido del objeto a editar
        //         Object.keys($event).forEach(key => {
        //             let valor = $event[key];
        //             if(input.key == key){
        //                 input.valor = valor;
        //             }
        //         });
        //     });
            
        //     this.inputs[0].valor = new Date($event['fecha_produccion']);
        //     let tipo_lote = await this.$buscarObjeto($event['tipo_lotes_id'],this.tipo_lotes);
        //     this.inputs[1].valor = tipo_lote;
        //     let tipo_mp = await this.$buscarObjeto($event['tipo_mps_id'],this.especies);
        //     console.log('tipo_mp',tipo_mp);
        //     this.inputs[2].valor = tipo_mp;
        //     let estado = await this.$buscarObjeto($event['cerrado'],this.estados);
        //     this.inputs[4].valor = estado;
        //     // let restriccion = await this.$buscarObjeto($event['restricciones_id'],this.restricciones);
        //     // this.inputs[2].valor = restriccion;
            
        //     this.configuracion_modal.titulo_modal = 'Editar Lote';

        //     this.configuracion_modal.boton_submit = 'Actualizar';
        //     this.configuracion_modal.ruta = `lotes/${$event.id}`;
        //     this.configuracion_modal.tipo_peticion = 'PUT';
        //     this.$emit('abrir',this.inputs,this.configuracion_modal);
        //     console.log('inputs',this.inputs);
        // },

        abrir_modal_confirmacion($event){
            let configuracion = {
                titulo:`Cerrar Lote`,
                mensaje:`¿ Está Seguro de Cerrar el Lote N° ${$event.nombre_lote}?`,
                border:'top',
                tipo:'warning'
            }
            Event.$emit('abrir_modal_confirmacion',configuracion,$event);
        },

        async cerrar_lote($event){
            //this.mostrarLoading('Cerrando Lote...')
            this.mostrarLoading({titulo:'Cerrando Lote...',color:'green'})

            //cerrar un lote
            let url = `${this.base_url}lote/${$event.id}/cerrar`;
            await this.axios.put(url,{},this.headers).then((response)=>{
                Event.$emit('cerrar_modal_confirmacion');
                this.ocultarLoading();
                this.cargarDatos();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
            console.log('lote a cerrar',$event.id);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading','actualizarTablaPaginada'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        Tabla,
        'modal':Modal,
        'data-table':Data_Table,
        'modal-confirmacion':Modal_Confirmacion,
        'modal-lotes':Modal_Lotes,
        'modal-muestreos':Modal_Muestreos,
        'tabla-paginada':TablaPaginadaVue,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .container{width:98%; max-width: 98%!important;}
</style>